import ReactDOM from 'react-dom'

export function usePortal() {
  const container = document.getElementById('content') || document.body

  return (children) => ReactDOM.createPortal(children, container)
}
